import { SVGProps, Ref, forwardRef } from "react";

const ArrowDownIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Arrow Down Icon"
    strokeWidth={2}
    {...props}
  >
    <title id="Arrow Down Icon">Arrow Down Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 5v14m0 0 7-7m-7 7-7-7"
    />
  </svg>
);

const ForwardRef = forwardRef(ArrowDownIcon);

export default ForwardRef;
